<template>
  <Modal :id="'cmp-distribution-shops-shop_management'" @cancelled="onCancel">
    <template slot="header">{{ $t("shop_management") }}</template>

    <template slot="body">
      <NTable
        class="dbox1"
        id="distribution-shops-shop_management-list"
        :config="tableConfig"
        :headers="headers"
        :items="list || []"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('channel')">
              <span class="txtov">
                {{ $dft.capHead($t(item["external_table"]).slice(0, -5)) }}
              </span>
              <!-- <span
                class="txtov"
                v-if="item['external_table'] == 'digital_shop'"
                >{{ $t("Digital") }}</span
              >
              <span
                class="txtov"
                v-if="item['external_table'] == 'physical_shop'"
                >{{ $t("Physical") }}</span
              > -->
            </td>
            <td v-bind="tdcon('current_name')">
              <span class="txtov" :title="item['text01']">
                {{ item["text01"] }}
              </span>
            </td>
            <td v-bind="tdcon('new_name')">
              <TextField2
                :id="'text02'"
                :showLabel="false"
                :value="item['text02']"
                @blur="e => onTextFieldValueChange(e, item)"
                :bb="'0px'"
              />
            </td>

            <td v-bind="tdcon('transfer_to_account')">
              <Dropdown2
                class="dbox1"
                :bb="'0px'"
                :showLabel="false"
                :options="
                  item['external_table'] == 'digital_shop'
                    ? digitalTV
                    : physicalTV
                "
                :placeholder="`${$t('Transfer')} ${$t('Account')}`"
                :selected="
                  (item['external_table'] == 'digital_shop'
                    ? digitalTV
                    : physicalTV
                  ).find(v => v.value == item.external_id)
                "
                v-on:selectedChange="
                  e => onDropDownChange('external_id', e, item)
                "
              >
              </Dropdown2>
            </td>

            <td v-bind="tdcon('mechanical')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="'external_id2'"
                    :id="'external_id2'"
                    :checked="item['external_id2']"
                    @click="e => onCheckBoxChange(e, 'external_id2', item)"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">
        {{ $t("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { ShopsService } from "../../services/shops.service";
import { createTV } from "../../../../models/text-value.model";
import { async } from "ramda-adjunct";
import { MHTTPCL } from "../../../../services/http/http-client";

export default {
  components: {
    Modal,
    NTable,
    InputField
  },
  props: {},
  data: function() {
    return {
      list: [],
      digitalAccounts: [],
      physicalAccounts: [],

      shops: {}
    };
  },
  mounted: async function() {
    const res = await ShopsService.getShopManagement();
    console.log("Shop Management ", res.data);

    this.list = res.data.shops;
    this.digitalAccounts = res.data.digital_accounts;
    this.physicalAccounts = res.data.physical_accounts;
  },
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    headers: function() {
      return [
        createTableHeader("channel", { f: 0.6 }),
        createTableHeader("current_name", { f: 0.6 }),
        createTableHeader("new_name"),
        createTableHeader("transfer_to_account"),
        createTableHeader("mechanical", { text: "Excl Mechanicals", mw: 124 })
      ];
    },
    shop_id: function() {
      return this.$route.params.shop_id;
    },

    digitalTV: function() {
      return createTV(this.digitalAccounts, "account_name", "account_id");
    },
    physicalTV: function() {
      return createTV(this.physicalAccounts, "account_name", "account_id");
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },

    onTextFieldValueChange: async function({ name, value }, item) {
      console.log("text field ", { name, value }, item);

      this.list = this.list.map(element => {
        if (element.relation_id == item.relation_id) {
          return {
            ...element,
            [name]: value
          };
        } else {
          return element;
        }
      });

      const table = "l_relations";

      await MHTTPCL.modifyJSON(
        undefined,
        item.relation_id,
        name,
        value,
        "l_relations"
      );

      await ShopsService.saveShopName(item.relation_id, value);
      // console.log("sss ", res.data, typeof res.data);
      // this.shops = res.data;
    },

    onCheckBoxChange: async function(event, name, item) {
      // console.log("onCheckBoxChange ", event, name, item);
      // console.log(event.target.checked);
      const value = event.target.checked ? "1" : "";

      this.list = this.list.map(element => {
        if (element.relation_id == item.relation_id) {
          return {
            ...element,
            relation_id: value ? element.relation_id : ""
          };
        } else {
          return element;
        }
      });

      await MHTTPCL.modifyJSON(
        undefined,
        item.relation_id,
        name,
        value,
        "l_relations"
      );
    },

    onDropDownChange: async function(name, event, item) {
      // console.log("Dropddown ", { name, event, item });

      this.list = this.list.map(element => {
        if (element.relation_id == item.relation_id) {
          return {
            ...element,
            [name]: event.value
          };
        } else {
          return element;
        }
      });

      // console.log("list", this.list);

      await MHTTPCL.modifyJSON(
        undefined,
        item.relation_id,
        name,
        event.value,
        "l_relations"
      );
    },

    onOkClick: async function() {
      console.log("okkkkk ", this.shops);
      await ShopsService.updateShopName();
      this.$emit("added", true);
    }

    // MARK: Methods
  }
};
</script>

<style lang="scss" scoped>
.cmp-distribution-shops-shop_management {
  .distribution-shops-shop_management-list {
    --ntable-height: 252px !important;
  }
}
</style>
